import React from 'react';
import './style.css';
import { PulseLoader } from 'react-spinners';

// HOC para gerenciar as instâncias
const withLoadingSingleton = (WrappedComponent) => {
  class WithLoadingSingleton extends React.Component {
    static instances = [];

    constructor(props) {
      super(props);
      this.id = Math.random().toString(36).substr(2, 9);
      WithLoadingSingleton.instances.push(this);
      this.state = { isActive: WithLoadingSingleton.instances[0] === this };
    }

    componentWillUnmount() {
      WithLoadingSingleton.instances = WithLoadingSingleton.instances.filter(
        (instance) => instance !== this,
      );

      // Atualiza a instância ativa se necessário
      if (this.state.isActive && WithLoadingSingleton.instances.length > 0) {
        WithLoadingSingleton.instances[0].setState({ isActive: true });
      }
    }

    render() {
      if (!this.state.isActive) return null;

      return <WrappedComponent {...this.props} />;
    }
  }

  return WithLoadingSingleton;
};

// Componente Loading base
class BaseLoading extends React.Component {
  render() {
    return (
      <div className="loading">
        <div className="loading-content">
          <PulseLoader color="#FFF" />
          <div className="loading-text">CARREGANDO</div>
        </div>
      </div>
    );
  }
}

// Exporta o Loading com o HOC
export default withLoadingSingleton(BaseLoading);
